import React, { createContext, useEffect, useState } from "react";

export const ShopContext = createContext(null);

const getDefaultCart = () => {
  let cart = {};
  for (let index = 0; index <= 300; index++) {
    cart[index] = { quantity: 0, size: null };
  }
  return cart;
};

const ShopContextProvider = (props) => {
  const [all_Product, setAllProducts] = useState([]);
  const [cartItems, setCartItems] = useState(getDefaultCart());
  const [selectedSize, setSelectedSize] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // --- URL #1 CORRECTED (removed /api) ---
        const response = await fetch('/api/allproducts');
        if (!response.ok) {
          throw new Error('Error fetching products: ' + response.statusText);
        }
        const data = await response.json();
        setAllProducts(data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();

    const authToken = localStorage.getItem('auth-token');
    if (authToken) {
      // --- URL #2 CORRECTED (removed /api) ---
      fetch('/getcart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'auth-token': authToken,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Error fetching cart: ' + response.statusText);
          }
          return response.json();
        })
        .then((data) => setCartItems(data))
        .catch((error) => console.error('Error fetching cart:', error));
    }
  }, []);

  const addToCart = (itemId, size) => {
    setCartItems((prev) => {
      const newCount = prev[itemId] ? prev[itemId].quantity + 1 : 1;
      return { ...prev, [itemId]: { quantity: newCount, size: size || prev[itemId].size } };
    });

    setSelectedSize(size);

    const authToken = localStorage.getItem('auth-token');
    if (authToken) {
      // --- URL #3 CORRECTED (removed /api) ---
      fetch('/addtocart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'auth-token': authToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ itemId, size }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
        })
        .then((data) => console.log('Response from addtocart:', data))
        .catch((error) => console.error('Error adding to cart:', error));
    }
  };

  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({
      ...prev,
      [itemId]: { ...prev[itemId], quantity: prev[itemId].quantity - 1 }
    }));

    const authToken = localStorage.getItem('auth-token');
    if (authToken) {
      // --- URL #4 CORRECTED (removed /api) ---
      fetch('/removefromcart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'auth-token': authToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ itemId }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
        })
        .then((data) => console.log('Response from removefromcart:', data))
        .catch((error) => console.error('Error removing from cart:', error));
    }
  };

  const getTotalCartAmount = () => {
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item].quantity > 0) {
        let itemInfo = all_Product.find((product) => product.id === Number(item));
        if (itemInfo) {
          totalAmount += itemInfo.new_price * cartItems[item].quantity;
        }
      }
    }
    return totalAmount;
  };

  const getCartItemCount = () => {
    let itemCount = 0;
    for (const item in cartItems) {
      if (cartItems[item].quantity > 0) {
        itemCount += 1;
      }
    }
    return itemCount;
  };

  const getSubtotalBeforeDiscount = () => {
    let subtotal = 0;
    for (const item in cartItems) {
      if (cartItems[item].quantity > 0) {
        let itemInfo = all_Product.find((product) => product.id === Number(item));
        if (itemInfo) {
          subtotal += itemInfo.new_price * cartItems[item].quantity;
        }
      }
    }
    return subtotal;
  };

  const calculatePromotionDiscount = () => {
    const subtotal = getSubtotalBeforeDiscount();
    const itemCount = getCartItemCount();
    
    if (itemCount >= 2 && subtotal > 1500) {
      return 1000;
    }
    return 0;
  };

  const getFinalCartAmount = () => {
    const subtotal = getSubtotalBeforeDiscount();
    const deliveryFee = subtotal > 1500 ? 0 : 100.00;
    return Math.max(0, subtotal + deliveryFee);
  };

  const getTotalCartItems = () => {
    let totalItem = 0;
    for (const item in cartItems) {
      if (cartItems[item].quantity > 0) {
        totalItem += cartItems[item].quantity;
      }
    }
    return totalItem;
  };

  const contextValue = {
    all_Product,
    getTotalCartItems,
    getTotalCartAmount,
    getCartItemCount,
    getSubtotalBeforeDiscount,
    calculatePromotionDiscount,
    getFinalCartAmount,
    cartItems,
    addToCart,
    removeFromCart,
    selectedSize,
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;